<template>
  <div class="top-bar py-2 text-bg-primary">
    <div class="container">

      <cmsBlockSimple v-if="typeof HeaderTop == 'object'" :identifier="HeaderTop.identifier" class="header-top-text"/>
    </div>
  </div>
</template>

<script>
import getImageUrl from "@/base/helpers/getImageUrl.js";
import cmsBlockSimple from "@/esf_antarctica_lederhosenland/core/components/common/BlockSimple.vue";

export default {
  components: {
    cmsBlockSimple
  },
  computed: {
    HeaderTop() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
        "Header_Top"
      );
    },
  },
  data: () => ({
    showSearchMobile: false,
  }),
  methods: {
    handleSearchMobile(value) {
      this.showSearchMobile = value;
    },
    imgUrl(fileName) {
      return getImageUrl(fileName);
    },
  },
};
</script>

<style></style>